<template>
  <div>
    <v-container fluid>
      <print mode="releaseNote" :releaseNoteList="releaseNoteList"></print>
    </v-container>
  </div>
</template>

<script>
import Print from "@/components/printReleaseNote";

export default {
  name: "printReleaseNote",
  components: {
    Print,
  },
  computed: {
    releaseNoteList() {
      return this.$route.params.releaseNoteList;
    },
  },
};
</script>
